import { useQuery } from 'react-query'

import {
  fetchInspectionTargetZones,
  fetchInspectionViewpointZones,
} from '../../../../api/inspectionTargetZones'

export const useInspectionViewpointZonesQuery = (
  projectId: string,
  enabled = true,
) => {
  return useQuery(
    ['inspection-viewpoint-zones', projectId],
    async () => fetchInspectionViewpointZones(projectId),
    { enabled: enabled && !!projectId },
  )
}

export const useInspectionTargetZonesQuery = (
  projectId: string,
  viewpointZoneId?: number | null,
  enabled = true,
) => {
  return useQuery(
    ['inspection-target-zones', projectId, viewpointZoneId],
    async () => fetchInspectionTargetZones(projectId, viewpointZoneId),
    { enabled: enabled && !!projectId && !!viewpointZoneId },
  )
}
